import Colors from "/styles/colors";
export const componentStyles = new String(".hp-textarea-input{width:100%;max-width:100%;height:106px;resize:none}");
componentStyles.__hash = "cd455d3ac866b4ba";
